import React, { Suspense, useLayoutEffect, useState } from 'react';
import StrategiesContextProvider from './context/strategies_context';
import StrategiesContextProviderVer2 from './context/strategies_context_v2';
import { SpinnerWrapper } from './funds/v2/strategy-landing/components/Spinner.styles';
import Spinner from './funds/v2/strategy-landing/components/Spinner';

/**
 * The application in fact is a wrapper for 3 different components (or views depending
 * what nomenclature you use). The idea is to output a single bundle and load the requested
 * component by simply changing data-component HTML attribute.
 * In order to do so, we lazy-load all components and select which of them should be shown
 * by reading `component` property out of a #root div dataset.
 */
const components = {
  screener: React.lazy(() =>
    import(/* webpackChunkName: "screener" */ './funds/v1/index.js')
  ),
  strategy: React.lazy(() =>
    import(/* webpackChunkName: "strategy" */ './funds/v2/strategy/index.js')
  ),
  vehicle: React.lazy(() =>
    import(/* webpackChunkName: "vehicle" */ './funds/v2/vehicle/index.js')
  ),
  'etf-vehicle': React.lazy(() =>
    import(/* webpackChunkName: "vehicle" */ './funds/v2/etf-vehicle/index.js')
  ),
  'strategy-landing': React.lazy(() =>
    import(
      /* webpackChunkName: "strategy-landing" */ './funds/v2/strategy-landing/index.js'
    )
  ),
};

const rootElement = document.getElementById('root');

const App = () => {
  const [rootConfig, setRootConfig] = useState(null);

  useLayoutEffect(() => {
    const { component, strategy, vehicle } = rootElement.dataset;
    setRootConfig({
      selectedComponent: component || 'screener',
      strategyName: strategy,
      vehicleName: vehicle,
    });
  }, []);

  if (!rootConfig?.selectedComponent) {
    return null;
  }

  const Component = components[rootConfig.selectedComponent];

  return (
    <React.Fragment>
      <SpinnerWrapper className="wrapper-spinner">
        <Spinner isLarge={true} />
      </SpinnerWrapper>
      <Suspense
        fallback={null}
      >
        {rootConfig.selectedComponent === 'screener' ? (
          <Component />
        ) : (
          <React.Fragment>
            {rootConfig.selectedComponent === 'etf-vehicle' ? (
              <StrategiesContextProviderVer2
                strategyName={rootConfig.strategyName}
                vehicleName={rootConfig.vehicleName}
              >
                <div className='wrapper-content'>
                  <Component />
                </div>
              </StrategiesContextProviderVer2>
            ) : (
              <StrategiesContextProvider
                strategyName={rootConfig.strategyName}
                vehicleName={rootConfig.vehicleName}
              >
                <div className='wrapper-content'>
                  <Component />
                </div>
              </StrategiesContextProvider>
            )}
          </React.Fragment>
        )}
      </Suspense>
    </React.Fragment>
  );
};

export default App;
